import { PLATFORM_DASHBOARD_READ, PLATFORM_DATA_HUB_READ, PLATFORM_REPORTS_READ, } from '../../operations/dashboard.operations.js';
import { MARKET_PRICES_GET, MARKET_PRICES_LIST } from '../../operations/market-data.operations.js';
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_REFRESH, AUTH_PASSWORD_CHANGE, AUTH_SESSION_MANAGE, AUTH_SESSION_REVOKE, AUTH_ENROLL_MFA, AUTH_VERIFY_MFA, AUTH_DISABLE_MFA, AUTH_REGENERATE_BACKUP_CODES, AUTH_READ_PROFILE, AUTH_SWITCH_CONTEXT, AUTH_ENTER_DELEGATION, AUTH_EXIT_DELEGATION, ADMIN_HUB, NAVIGATION_SHELL_READ, NAVIGATION_ROUTES_READ, NAVIGATION_ROUTE_READ, NAVIGATION_HUB_READ, SETTINGS_VIEW, SETTINGS_PROFILE, SETTINGS_PROFILE_UPDATE, SETTINGS_PREFERENCES, SETTINGS_PREFERENCES_UPDATE, SETTINGS_MFA, SETTINGS_SECURITY, PLATFORM_HEALTH_CHECK, PLATFORM_HEALTH_READINESS, PLATFORM_HEALTH_LIVENESS, PLATFORM_METRICS_READ, PLATFORM_METRICS_READ_JSON, PLATFORM_ORGANIZATIONS_LIST, PLATFORM_ORGANIZATIONS_READ, PLATFORM_ORGANIZATIONS_CREATE, PLATFORM_ORGANIZATIONS_UPDATE, PLATFORM_ORGANIZATIONS_DISABLE, PLATFORM_ORGANIZATIONS_OFFBOARDING_EXPORT, PLATFORM_MODULES_LIST, PLATFORM_MODULES_READ, PLATFORM_MODULE_ENABLE, PLATFORM_MODULE_DISABLE, PLATFORM_ENTITLEMENTS_LIST, PLATFORM_MODULES_ASSIGN, PLATFORM_MODULES_REVOKE, PLATFORM_MODULES_CATALOG_LIST, PLATFORM_MODULES_CATALOG_MANAGE, PLATFORM_MODULES_ASSIGN_TO_ORGANIZATION, PLATFORM_MODULES_REVOKE_FROM_ORGANIZATION, PLATFORM_USERS_LIST, PLATFORM_USERS_READ, PLATFORM_USERS_CREATE, PLATFORM_USERS_UPDATE, PLATFORM_USERS_DISABLE, PLATFORM_AUDIT_LIST, PLATFORM_AUDIT_READ, PLATFORM_AUDIT_EXPORT, PLATFORM_REPORT_SNAPSHOT_CREATE, PLATFORM_REPORT_RESTATEMENT_CREATE, PLATFORM_CONFIGURATION_ROLLOUT_READ, PLATFORM_CONFIGURATION_ROLLOUT_MANAGE, PLATFORM_DATA_RESIDENCY_READ, PLATFORM_DATA_RESIDENCY_POLICY_UPDATE, PLATFORM_DATA_RESIDENCY_TRANSFER_EVALUATE, PLATFORM_DATA_RESIDENCY_EXCEPTION_APPROVE, PLATFORM_JURISDICTION_PACKAGES_READ, PLATFORM_JURISDICTION_PACKAGES_MANAGE, PLATFORM_REFERENCE_MASTER_READ, PLATFORM_REFERENCE_MASTER_MANAGE, PLATFORM_MARKET_DATA_QUALITY_READ, PLATFORM_MARKET_DATA_QUALITY_MANAGE, PLATFORM_MARKET_DATA_QUALITY_APPROVE, PLATFORM_PROVIDER_INGESTION_READ, PLATFORM_PROVIDER_INGESTION_MANAGE, PLATFORM_ISSUER_EVENTS_READ, PLATFORM_ISSUER_EVENTS_MANAGE, PLATFORM_ISSUER_EVENTS_APPROVE, PLATFORM_PERMISSION_CATALOG_MIGRATIONS_READ, PLATFORM_PERMISSION_CATALOG_MIGRATIONS_MANAGE, PLATFORM_FEDERATION_READ, PLATFORM_FEDERATION_MANAGE, PLATFORM_SERVICE_ACCOUNTS_READ, PLATFORM_SERVICE_ACCOUNTS_MANAGE, PLATFORM_ACCESS_REVIEWS_READ, PLATFORM_ACCESS_REVIEWS_MANAGE, PLATFORM_CRYPTOGRAPHIC_KEYS_READ, PLATFORM_CRYPTOGRAPHIC_KEYS_MANAGE, PLATFORM_SCHEDULED_CONTROLS_READ, PLATFORM_SCHEDULED_CONTROLS_MANAGE, PLATFORM_SCHEDULED_CONTROLS_APPROVE, PLATFORM_SECURITY_INCIDENTS_READ, PLATFORM_SECURITY_INCIDENTS_MANAGE, PLATFORM_ORGANIZATION_OWNERSHIP_READ, PLATFORM_ORGANIZATION_OWNERSHIP_REQUEST, PLATFORM_ORGANIZATION_OWNERSHIP_APPROVE, PLATFORM_MIGRATION_GOVERNANCE_READ, PLATFORM_MIGRATION_GOVERNANCE_REQUEST, PLATFORM_MIGRATION_GOVERNANCE_APPROVE, PLATFORM_ORGANIZATION_PORTABILITY_READ, PLATFORM_ORGANIZATION_PORTABILITY_REQUEST, PLATFORM_ORGANIZATION_PORTABILITY_APPROVE, PLATFORM_ORGANIZATION_PORTABILITY_PURGE, PLATFORM_NOTIFICATION_GOVERNANCE_READ, PLATFORM_NOTIFICATION_GOVERNANCE_MANAGE, PLATFORM_NOTIFICATION_GOVERNANCE_APPROVE, PLATFORM_SUPPORT_DELEGATIONS_LIST, PLATFORM_SUPPORT_DELEGATIONS_READ, PLATFORM_SUPPORT_DELEGATIONS_CREATE, PLATFORM_SUPPORT_DELEGATIONS_APPROVE, PLATFORM_SUPPORT_DELEGATIONS_REVOKE, PLATFORM_LICENSE_LIST, PLATFORM_LICENSE_CREATE, ACCESS_READ_PERMISSIONS, INSTRUMENT_LIST, INSTRUMENT_GET, INSTRUMENT_CREATE, INSTRUMENT_UPDATE, INSTRUMENT_BULK_UPSERT, MARKET_DATA_LIST, MARKET_DATA_GET, MARKET_DATA_CREATE, MARKET_DATA_UPDATE, MARKET_DATA_DELETE, MARKET_DATA_BULK_UPSERT, } from '../../operations/operation-ids.js';
/**
 * Platform root: full platform-scope mutation. No organization business-data
 * operations without an active delegation record.
 *
 * Canonical instruments are platform-owned shared reference data. Platform
 * administrators may create, update, activate/deactivate, and bulk upsert those
 * records. Destructive deletion remains intentionally outside the platform
 * bundle because referenced security-master records must preserve history.
 *
 * Market prices remain read-only through the live platform experience until a
 * versioned correction/supersession workflow is available. Existing legacy
 * market-data mutation endpoints are not promoted merely because they exist.
 */
export const PLATFORM_ROOT_OPERATIONS = [
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_REFRESH,
    AUTH_PASSWORD_CHANGE,
    AUTH_SESSION_MANAGE,
    AUTH_SESSION_REVOKE,
    AUTH_ENROLL_MFA,
    AUTH_VERIFY_MFA,
    AUTH_DISABLE_MFA,
    AUTH_REGENERATE_BACKUP_CODES,
    AUTH_READ_PROFILE,
    AUTH_SWITCH_CONTEXT,
    AUTH_ENTER_DELEGATION,
    AUTH_EXIT_DELEGATION,
    PLATFORM_DASHBOARD_READ,
    PLATFORM_DATA_HUB_READ,
    PLATFORM_REPORTS_READ,
    ADMIN_HUB,
    NAVIGATION_SHELL_READ,
    NAVIGATION_ROUTES_READ,
    NAVIGATION_ROUTE_READ,
    NAVIGATION_HUB_READ,
    SETTINGS_VIEW,
    SETTINGS_PROFILE,
    SETTINGS_PROFILE_UPDATE,
    SETTINGS_PREFERENCES,
    SETTINGS_PREFERENCES_UPDATE,
    SETTINGS_MFA,
    SETTINGS_SECURITY,
    PLATFORM_HEALTH_CHECK,
    PLATFORM_HEALTH_READINESS,
    PLATFORM_HEALTH_LIVENESS,
    PLATFORM_METRICS_READ,
    PLATFORM_METRICS_READ_JSON,
    PLATFORM_ORGANIZATIONS_LIST,
    PLATFORM_ORGANIZATIONS_READ,
    PLATFORM_ORGANIZATIONS_CREATE,
    PLATFORM_ORGANIZATIONS_UPDATE,
    PLATFORM_ORGANIZATIONS_DISABLE,
    PLATFORM_ORGANIZATIONS_OFFBOARDING_EXPORT,
    PLATFORM_MODULES_LIST,
    PLATFORM_MODULES_READ,
    PLATFORM_MODULE_ENABLE,
    PLATFORM_MODULE_DISABLE,
    PLATFORM_ENTITLEMENTS_LIST,
    PLATFORM_MODULES_ASSIGN,
    PLATFORM_MODULES_REVOKE,
    PLATFORM_MODULES_CATALOG_LIST,
    PLATFORM_MODULES_CATALOG_MANAGE,
    PLATFORM_MODULES_ASSIGN_TO_ORGANIZATION,
    PLATFORM_MODULES_REVOKE_FROM_ORGANIZATION,
    PLATFORM_USERS_LIST,
    PLATFORM_USERS_READ,
    PLATFORM_USERS_CREATE,
    PLATFORM_USERS_UPDATE,
    PLATFORM_USERS_DISABLE,
    PLATFORM_AUDIT_LIST,
    PLATFORM_AUDIT_READ,
    PLATFORM_AUDIT_EXPORT,
    PLATFORM_REPORT_SNAPSHOT_CREATE,
    PLATFORM_REPORT_RESTATEMENT_CREATE,
    PLATFORM_CONFIGURATION_ROLLOUT_READ,
    PLATFORM_CONFIGURATION_ROLLOUT_MANAGE,
    PLATFORM_DATA_RESIDENCY_READ,
    PLATFORM_DATA_RESIDENCY_POLICY_UPDATE,
    PLATFORM_DATA_RESIDENCY_TRANSFER_EVALUATE,
    PLATFORM_DATA_RESIDENCY_EXCEPTION_APPROVE,
    PLATFORM_JURISDICTION_PACKAGES_READ,
    PLATFORM_JURISDICTION_PACKAGES_MANAGE,
    PLATFORM_REFERENCE_MASTER_READ,
    PLATFORM_REFERENCE_MASTER_MANAGE,
    PLATFORM_MARKET_DATA_QUALITY_READ,
    PLATFORM_MARKET_DATA_QUALITY_MANAGE,
    PLATFORM_MARKET_DATA_QUALITY_APPROVE,
    PLATFORM_PROVIDER_INGESTION_READ,
    PLATFORM_PROVIDER_INGESTION_MANAGE,
    PLATFORM_ISSUER_EVENTS_READ,
    PLATFORM_ISSUER_EVENTS_MANAGE,
    PLATFORM_ISSUER_EVENTS_APPROVE,
    PLATFORM_PERMISSION_CATALOG_MIGRATIONS_READ,
    PLATFORM_PERMISSION_CATALOG_MIGRATIONS_MANAGE,
    PLATFORM_FEDERATION_READ,
    PLATFORM_FEDERATION_MANAGE,
    PLATFORM_SERVICE_ACCOUNTS_READ,
    PLATFORM_SERVICE_ACCOUNTS_MANAGE,
    PLATFORM_ACCESS_REVIEWS_READ,
    PLATFORM_ACCESS_REVIEWS_MANAGE,
    PLATFORM_CRYPTOGRAPHIC_KEYS_READ,
    PLATFORM_CRYPTOGRAPHIC_KEYS_MANAGE,
    PLATFORM_SCHEDULED_CONTROLS_READ,
    PLATFORM_SCHEDULED_CONTROLS_MANAGE,
    PLATFORM_SCHEDULED_CONTROLS_APPROVE,
    PLATFORM_SECURITY_INCIDENTS_READ,
    PLATFORM_SECURITY_INCIDENTS_MANAGE,
    PLATFORM_ORGANIZATION_OWNERSHIP_READ,
    PLATFORM_ORGANIZATION_OWNERSHIP_REQUEST,
    PLATFORM_ORGANIZATION_OWNERSHIP_APPROVE,
    PLATFORM_MIGRATION_GOVERNANCE_READ,
    PLATFORM_MIGRATION_GOVERNANCE_REQUEST,
    PLATFORM_MIGRATION_GOVERNANCE_APPROVE,
    PLATFORM_ORGANIZATION_PORTABILITY_READ,
    PLATFORM_ORGANIZATION_PORTABILITY_REQUEST,
    PLATFORM_ORGANIZATION_PORTABILITY_APPROVE,
    PLATFORM_ORGANIZATION_PORTABILITY_PURGE,
    PLATFORM_NOTIFICATION_GOVERNANCE_READ,
    PLATFORM_NOTIFICATION_GOVERNANCE_MANAGE,
    PLATFORM_NOTIFICATION_GOVERNANCE_APPROVE,
    PLATFORM_SUPPORT_DELEGATIONS_LIST,
    PLATFORM_SUPPORT_DELEGATIONS_READ,
    PLATFORM_SUPPORT_DELEGATIONS_CREATE,
    PLATFORM_SUPPORT_DELEGATIONS_APPROVE,
    PLATFORM_SUPPORT_DELEGATIONS_REVOKE,
    PLATFORM_LICENSE_LIST,
    PLATFORM_LICENSE_CREATE,
    ACCESS_READ_PERMISSIONS,
    INSTRUMENT_LIST,
    INSTRUMENT_GET,
    INSTRUMENT_CREATE,
    INSTRUMENT_UPDATE,
    INSTRUMENT_BULK_UPSERT,
    MARKET_DATA_LIST,
    MARKET_DATA_GET,
    MARKET_DATA_CREATE,
    MARKET_DATA_UPDATE,
    MARKET_DATA_DELETE,
    MARKET_DATA_BULK_UPSERT,
    MARKET_PRICES_LIST,
    MARKET_PRICES_GET,
];
